
import * as Entity from './Entity'
import * as EntityCache from './EntityCache'
import * as EntityCollection from './EntityCollection'
import * as JMan from './JMan'
import * as JManError from './JManError'

let exports = {};
for (const Module of [
	Entity,
	EntityCache,
	EntityCollection,
	JMan,
	JManError
]) {
	for (const key in Module) {
		exports[key] = Module[key];
	}
}

// console.log("EXPORTS", exports);

export default exports;



// WEBPACK FOOTER //
// ./src/assets/js/JMan/index.js